import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import { Event as BaseEvent } from '../definitions/common';
import CardPreference from './CardPreference';
import DisplayedCard from './DisplayedCard';
import Contact from './Contact';
import HostedApplication from './HostedApplication';
import CreditReport from './CreditReport';


const CardClick = types
    .model('CardClick', {
        // TODO: Remove integer once legacy Id migrated https://ratehub.atlassian.net/browse/CCDEP-2853
        cardId: types.maybe(types.union(types.string, types.integer)),
        isMonetized: types.maybe(types.boolean),
        billingType: types.maybe(types.string),
    });

const CardInquiry = types
    .model('CardInquiry', {
        // TODO: Remove integer once legacy Id migrated https://ratehub.atlassian.net/browse/CCDEP-2853
        appliedCardId: types.maybe(types.union(types.string, types.integer)),
        displayedCards: types.optional(types.array(DisplayedCard), []),
    });

const CardLead = types
    .model('CardLead', {
        // TODO: Remove integer once legacy Id migrated https://ratehub.atlassian.net/browse/CCDEP-2853
        cardId: types.maybe(types.union(types.string, types.integer)),
        applicationId: types.maybe(types.string),
        isMonetized: types.maybe(types.boolean),
    });

const SavedResult = types
    .model('SavedResult', {
        resultsUrl: types.maybe(types.string),
    });

const EVENT_TYPES = {
    HOSTED_APPLICATION: 'hosted-application',
    CREDIT_REPORT: 'credit-report',
    CARD_CLICK: 'card-click',
    CARD_INQUIRY: 'card-inquiry',
    CARD_LEAD: 'card-lead',
    SAVED_RESULT: 'saved-results',
};

const EVENTS = {
    [EVENT_TYPES.HOSTED_APPLICATION]: HostedApplication,
    [EVENT_TYPES.CREDIT_REPORT]: CreditReport,
    [EVENT_TYPES.CARD_CLICK]: CardClick,
    [EVENT_TYPES.CARD_INQUIRY]: CardInquiry,
    [EVENT_TYPES.CARD_LEAD]: CardLead,
    [EVENT_TYPES.SAVED_RESULT]: SavedResult,
};

const CreditCardEvent = types
    .model('CreditCardEvent', {
        id: types.optional(types.identifier, () => uuid()),
        type: types.maybe(types.enumeration(Object.values(EVENT_TYPES))),
        // Using frozen because details is static and exact type is not trivially inferable on creation
        details: types.maybe(types.frozen()),
        contact: types.optional(Contact, {}),
        cardPreference: types.optional(CardPreference, {}),
    });

const Event = types.compose('Event', BaseEvent, CreditCardEvent);

export {
    EVENT_TYPES,
    EVENTS,
};
export default Event;
